import styled from "styled-components";
//let { innerHeight, innerWidth } = window

// const ksh42 = require("../../static/image/ksh42.png");

export const WagesCheckContainer = styled.div`
    width:100%;
    .container{
        width:100%;
        height:100%;
      .container2 {
        margin: 20px auto;
        width: 95%;
        height: 100%;
       
        .titleText{
          font-size:18px;
          //color: darkgray;
        }
        
        .textContent{
            background: #ffffff;
            padding-top: 4px;
            padding-Bottom: 4px;
            border-radius: 8px;
        }
        
      }
        .font14{
            font-size:14px;
        }
        .height50{
            height:50px;
        }
        &>.hang1{
            width:100%;

            .icon{
                font-size:25px;
                color:#008ae6;
            }

            .wxts{
                color:#f71f1f;
                line-height:25px;
            }
        }

        &>.pickerBox{
            width:100%;
        }
        &>.pickerListBox{
            width:100%;

            .itemBox{
                height:50px;
            }
        }
    }

`
